module.exports = __webpack_public_path__ + "static/media/img_solution_three.55d46c8a.png";